import {} from "../../syntax/index.js";
import { Keyword } from "../textual/keyword.js";
/**
 * @public
 */
export var System;
(function (System) {
    /**
     * {@link https://drafts.csswg.org/css-color/#typedef-system-color}
     */
    System.parse = Keyword.parse("canvas", "canvastext", "linktext", "visitedtext", "activetext", "buttonface", "buttontext", "field", "fieldtext", "highlight", "highlighttext", "graytext");
})(System || (System = {}));
//# sourceMappingURL=system.js.map